import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonUtilsModule } from "../../../shared/components/common-utils/common-utils.module";
import { ProductRequestService } from "../../graphql/product-requests.service";
import { AttachmentTypeSelectorComponent } from "./attachment-type-selector.component";

@NgModule({
    imports: [
        CommonModule,
        CommonUtilsModule,
        FormsModule,
    ],
    exports: [
        AttachmentTypeSelectorComponent,
    ],
    declarations: [
        AttachmentTypeSelectorComponent,
    ],
    providers: [
        ProductRequestService,
    ],
})
export class AttachmentTypeSelectorModule {
}
